module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.user.email
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('email', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.active
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('active', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Contraseña (opcional):")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('password', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.profile_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('profile_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      key: profile.id
    }, [_vm._v("\n                " + _vm._s(profile.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.roles[0].id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('role', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Trabajador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditUser()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("Mi Equipo")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1"
    }, [(user.avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": user.avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(user.name) + " (" + _vm._s(user.roles[0].name) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.team ? user.team.name : '-') + " :\n                " + _vm._s(user.profile ? user.profile.name : '-') + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.accounts.length) + " Cuentas Asociadas\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [(user.active === 0) ? _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "title": "Estado"
      },
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'alert-triangle',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": '/admin/calendar/' + user.slug
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'calendar',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.removeUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile_id),
      expression: "user.profile_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "profile_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el perfil")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      key: profile.id,
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                  " + _vm._s(profile.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "leader"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employee"
    }
  }, [_vm._v("Trabajador")])])])]), _vm._v(" "), _vm._m(3)])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#user",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Usuario")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n              Crear\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0cb4080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/team/Team.vue
// module id = 486
// module chunks = 1